import React, { memo, useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import ptBR from 'date-fns/locale/pt-BR';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import { toastr } from 'react-redux-toastr';
import mag_glass from '../../../img/busca.svg';

import './FilterAprimoramento.css';
import { IaCreators } from '../../../../../store/actions/intelligence';
import { UserActions } from '../../../../../store/actions/users';

function FilterAprimoramento(props) {
  const [magDebounce, setMagDebounce] = useState(null);

  useEffect(() => {
    const initialValuesFilter = {
      start_date: new Date(new Date().setDate(new Date().getDate() - 1)),
      end_date: new Date(),
      status: 'none',
      query: '',
    };

    props.updateFilterCuration(initialValuesFilter);

    props.listCurationMessages(
      props.bot._id,
      10,
      initialValuesFilter.query,
      '',
      initialValuesFilter.status,
      initialValuesFilter.start_date,
      initialValuesFilter.end_date
    );
  }, []);

  const handleChangeFilter = (value, name) => {
    const newValue = { ...props.filterCuration };
    newValue[name] = value;
    props.updateFilterCuration(newValue);
    /*
        props.listCurationMessages(
            props.bot._id,
            10,
            newValue.query,
            '',
            newValue.status,
            newValue.start_date,
            newValue.end_date
        );
        */
  };

  const handleClickFiltrar = () => {
    if (
      props.filterCuration.start_date == 'Invalid Date' ||
      !props.filterCuration.start_date
    )
      return toastr.error('Ops', 'Data inicial incorreta!');
    if (
      props.filterCuration.end_date == 'Invalid Date' ||
      !props.filterCuration.end_date
    )
      return toastr.error('Ops', 'Data final incorreta!');
    props.listCurationMessages(
      props.bot._id,
      10,
      props.filterCuration.query,
      '',
      props.filterCuration.status,
      props.filterCuration.start_date,
      props.filterCuration.end_date
    );
  };

  const fetchAvailableMessages = (query) => {
    const bot_id = props.bot._id;
    if (!bot_id)
      return toastr.error('Ops', 'Não foi possível achar o bot relacionado');

    // handleChangeFilter(query, 'query');

    props.listCurationMessages(
      bot_id,
      10,
      query,
      '',
      props.filterCuration.status,
      props.filterCuration.start_date,
      props.filterCuration.end_date
    );
  };

  const setMagValueDebounce = (value) => {
    if (magDebounce) clearTimeout(magDebounce);

    const new_event = setTimeout(() => {
      fetchAvailableMessages(value);
    }, 500);

    setMagDebounce(new_event);
  };

  return (
    <div>
      <div className="container-search-aprimoramento">
        <div className="search-ultimos-dias">
          <span>Filtrar por:</span>
          <select
            className="search-select-status"
            value={props.filterCuration.status}
            name="status"
            onChange={(e) => handleChangeFilter(e.target.value, e.target.name)}
          >
            <option value="none">Pendentes</option>
            <option value="accepted">Aceitos</option>
            <option value="rejected">Rejeitados</option>
          </select>
        </div>
        <div className="search-ultimos-dias">
          <span>de:</span>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDateTimePicker
              name="start_date"
              value={props.filterCuration.start_date}
              ampm={false}
              onChange={(date) => handleChangeFilter(date, 'start_date')}
              className="sub-input"
              format="dd/MM/yyyy HH:mm"
              disableFuture
              maxDateMessage="A data não pode ser futura"
              invalidDateMessage=""
            />
          </MuiPickersUtilsProvider>
        </div>
        <div className="search-ultimos-dias">
          <span>até:</span>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDateTimePicker
              name="end_date"
              autoOk
              ampm={false}
              value={props.filterCuration.end_date}
              onChange={(date) => handleChangeFilter(date, 'end_date')}
              className="sub-input"
              format="dd/MM/yyyy HH:mm"
              disableFuture
              maxDateMessage="A data não pode ser futura"
              invalidDateMessage=""
            />
          </MuiPickersUtilsProvider>
        </div>
        <div className="search-ultimos-dias">
          <button className="btn btn-primary" onClick={handleClickFiltrar}>
            Filtrar
          </button>
        </div>
      </div>
      <div className="container-input-enhancement">
        <img src={mag_glass} alt="mag-glass" />
        <input
          disabled={props?.user?.selectedCompany?.claim?.name === 'Viewer'}
          type="text"
          placeholder="Busca"
          onChange={(e) => setMagValueDebounce(e.target.value)}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  curation: state.intelligence.curation,
  filterCuration: state.intelligence.filterCuration,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...UserActions,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(FilterAprimoramento)))
);
